import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Delete, Add, Edit } from "../HemeIconLibrary";

import Skeleton from "react-loading-skeleton";

import { useSelector, useDispatch } from "react-redux";
import { Button, Alert } from "../utils";
import { editFormReducer } from "../Store/reducers/uiSettings";

import FormContainer from "../components/Formik/formContainer";
import { getAllAddresses, getAllCountries } from "../Actions/orders";
import { setForm } from "../Store/reducers/uiSettings";
import BackCmp from "../components/BackCmp";

const AddressBook = () => {
  const { uisettings } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [CTA, setCTA] = useState();

  const {
    orders,
    user: { activeSite },
  } = useSelector((state) => state);

  useEffect(() => {
    getAllCountries();
  }, [orders.addresses]);

  useEffect(() => {
    if (activeSite) {
      getAllAddresses(activeSite?.id);
    }
  }, [activeSite]);

  const customStyles = {
    style: {
      border: "1px solid #DEE2E6",
    },
    headCells: {
      style: {
        backgroundColor: "#F9F4FF",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "24px",
        borderLeft: "1px solid #DEE2E6",
        borderTop: "1px solid #DEE2E6",
      },
    },
    cells: {
      style: {
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "20px",
        color: "#595959",
        borderLeft: "1px solid #DEE2E6",
      },
    },
  };

  return (
    <>
      <div className="max-w-[1440px] relative w-full min-h-screen mx-auto pt-[92px] md:pt-[130px] px-4 md:px-10 pb-5 mb-[85px] ">
        <div className="flex items-center mb-[29px]">
          <BackCmp />
          <Link to="/" className="font-medium text-[13px] leading-6 text-black hover:text-primary1 m-0 no-underline">
            Home
          </Link>
          <div className=" w-[2px] h-3 bg-black mx-1" />
          <Link to="/collection" className=" no-underline  font-medium text-[13px] leading-6 text-black m-0">
            Collection Kits
          </Link>
          <div className=" w-[2px] h-3 bg-black mx-1" />
          <Link to="/checkout" className=" no-underline  font-medium text-[13px] leading-6 text-black m-0">
            Checkout
          </Link>
          <div className=" w-[2px] h-3 bg-black mx-1" />
          <h5 className="font-medium text-[13px] leading-6 text-primary1 m-0">Address Book</h5>
        </div>
        <Alert />
        <br />
        <div className="w-full min-h-[100px] pt-[20px] px-[25px] pb-[20px] bg-white shadow-mdShadow mb-[30px]">
          <div className="flex items-center justify-between mb-[20px] ">
            <h3 className="font-bold text-xl leading-6 text-black mb-[10px]">Address Book</h3>
            <Button
              bg="bg-primary1"
              border="border-primary1"
              color="text-white"
              className="h-[48px] justify-center font-semibold"
              Icon={<Add color="#fff" />}
              text="Add New Address"
              cta={() => {
                dispatch(editFormReducer());
                dispatch(setForm({ state: true, type: "add-address-book" }));
              }}
            />
          </div>
          {orders?.addresses ? (
            <div className="border-r-[1px] border-b-[1px] border-solid border-[#DEE2E6]">
              <DataTable
                customStyles={customStyles}
                data={orders.addresses || []}
                columns={[
                  {
                    grow: 4,
                    name: "Address",
                    selector: (row) => row.address1 || row.address2,
                  },
                  {
                    grow: 2,
                    name: "Email",
                    selector: (row) => row?.email,
                  },
                  {
                    grow: 2,
                    name: "Phone",
                    selector: (row) => row?.phone,
                  },
                  {
                    grow: 1,
                    name: "Actions",
                    selector: (row) => (
                      <div className="flex gap-[20px] items-center">
                        <div
                          className="w-7 h-7 flex items-center justify-center rounded bg-[#F9F4FF] cursor-pointer"
                          onClick={() => {
                            dispatch(editFormReducer(row));
                            dispatch(setForm({ state: true, type: "add-address-book" }));
                          }}
                        >
                          <Edit color="#775FD5" />
                        </div>
                        <div
                          className="w-7 h-7 flex items-center justify-center rounded bg-[#F9F4FF] cursor-pointer"
                          onClick={() => {
                            dispatch(editFormReducer(row));
                            dispatch(setForm({ state: true, type: "delete-address" }));
                          }}
                        >
                          <Delete color="#F87FB1" />
                        </div>
                      </div>
                    ),
                  },
                ]}
              />
            </div>
          ) : (
            <>
              <br />
              <Skeleton count={4} />
              <br />
              <Skeleton count={4} />
              <br />
              <Skeleton count={4} />
            </>
          )}
        </div>
      </div>
      {uisettings?.openform && <FormContainer cta={CTA} setCTA={setCTA} />}
    </>
  );
};

export default AddressBook;
